import { render, staticRenderFns } from "./ActionGeneric.vue?vue&type=template&id=1a52d8ea&"
import script from "./ActionGeneric.vue?vue&type=script&lang=js&"
export * from "./ActionGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports